<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-07-20 15:40:57
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-08-01 15:44:00
-->
<template>
	<div class="flex flex-just-start">
		<span v-if="cellValue == 1">-</span>
		<span v-else-if="cellValue == 0">
			<span class="yx-color-primary cursor-pointer" @click="showUndoDialog">撤销</span>
		</span>
		<span v-else class="yx-color-primary cursor-pointer" @click="showFailedReason">查看失败原因</span>
		<Undo-dialog ref="undodialog" :operator="row.operator_name" :taskId="row.id"></Undo-dialog>
		<Failed-dialog ref="faileddialog"></Failed-dialog>
		<Failed-reason-dialog ref="failedReasonDialog" :taskId="row.id"></Failed-reason-dialog>
	</div>
</template>
<script>
import mixin from './mixin';
import UndoDialog from '@/views/talentCRM/allocatedRecord/components/undoDialog';
import FailedDialog from '@/views/talentCRM/allocatedRecord/components/failedDialog';
import FailedReasonDialog from '@/views/talentCRM/allocatedRecord/components/failedReasonDialog';
export default {
	mixins: [mixin],

	methods: {
		showUndoDialog() {
			this.$refs.undodialog.show();
		},
		showFailedReason() {
			this.$refs.failedReasonDialog.show();
		},
	},
	components: {
		UndoDialog,
		FailedDialog,
		FailedReasonDialog,
	},
};
</script>

<style lang="less" scoped></style>
